<template>
<div class="c-page footer-row">
	<!-- 预设日期按钮 -->
	<span class="table-count">总共<i class="icon-count">{{pageBean.totalNum}}</i>个项目</span>
	<Page :total="pageBean.totalPage*pageBean.pageSize"
		  :current.sync="tableParams.page"
		  :page-size="tableParams.pageSize"
          :page-size-opts="[10,20,50,100]"
          :show-sizer="true"
          @on-page-size-change="onPageSizeChange"
		  @on-change="onChange" />
</div>
</template>
<script>
export default {
    name: 'cPage',
    props: {
        //请求对象
        tableParams: {
            type: Object
        },
        //分页对象
        pageBean: {
            type: Object
        }
    },
    methods: {
        /*
         * @description 页码改变的回调，返回改变后的页码
         * @param page:number 页码
         */
        onChange(page) {
            this.$emit('update:tableParams', this.tableParams);
            this.$emit('on-change', page);
        },
        /*
         * @description 切换每页条数时的回调，返回切换后的每页条数
         * @param pageSize:number 每页页数
         */
        onPageSizeChange(pageSize) {
            this.tableParams.pageSize = pageSize;
            this.$emit('update:tableParams', this.tableParams);
            if (this.tableParams.page == 1) this.$emit('on-page-size-change', pageSize);
        }
    }
};
</script>
<style lang="scss">
.c-page {
    .ivu-select-selected-value {
        padding-left: 13px !important;
        padding-right: 29px !important;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/commons/cPage.vue